import { NextPage } from "next";
import { useRouter } from "next/router";
import { ChangeEvent, useState } from "react";
import Layout from "../../components/Layout";
import useStore from "../../store/store";
import { IEmployee } from "../../types/employee";
import { csvJSON } from "../../utils";
import { emailAddress, emailTemplates, routes } from "../../utils/constants";
import { emptyForm } from "./register";
import * as XLSX from "xlsx";
import BulkUploadErrorModal from "../../components/BulkUploadErrorModal";

function getBase64(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

const sendBulkEmail = async (file: File) => {
  const dataFromFile = await getBase64(file);
  console.log(dataFromFile);
  const response = await fetch(`/api/bulkEmail`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ dataFromFile }),
  });
  if (response.status === 200) {
    // alert("E-mails zijn verzonden");
  } else {
    // alert("Er is iets fout gegaan");
  }
};

const Bulk: NextPage = () => {
  const router = useRouter();
  const { bulkUpload, setLoading, bulkUploadErrors } = useStore();
  const [employees, setEmployees] = useState<IEmployee[]>([]);
  const [csv, setCsv] = useState<string | ArrayBuffer | null>();
  const [fileData, setFileData] = useState<File | null>(null);
  const downloadTemplate = () => {
    // const fields = Object.keys(data[0]);
    // const opts = { fields };
    let headers: string[] = [];
    for (let header in emptyForm) {
      if (header !== "_id" && header !== "dateOfregistration") {
        headers.push(header);
      }
    }
    const csv = headers.join(";");

    var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

    var link = document.createElement("a");

    if (link.download !== undefined) {
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "sparrow-template.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  const readFile = (e: ChangeEvent<HTMLInputElement>) => {
    const reader = new FileReader();
    reader.onload = function () {
      if (reader.result) {
        //@ts-ignore
        const isExcel = e.target.files[0].name.includes(".xlsx");
        console.log(isExcel);
        console.log(reader.result);
        if (isExcel) {
          const workbook = XLSX.read(reader.result, {
            type: "binary",
          });
          workbook.SheetNames.forEach((sheetName) => {
            // const Xrowobject = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);

            const object = XLSX.utils.sheet_to_json(
              workbook.Sheets[sheetName]
            ) as IEmployee[];
            setEmployees(object);
          });
        } else {
          setCsv(reader.result);

          const object = csvJSON(reader.result.toString()) as IEmployee[];
          setEmployees(object);
        }
        e.target.value = "";
      }
    };

    if (e.target.files) {
      setFileData(e.target.files[0]);
      reader.readAsBinaryString(e.target.files[0]);
    }
  };

  const saveEmployees = () => {
    setLoading(true);
    bulkUpload(employees);
    fileData && sendBulkEmail(fileData);
  };
  
  return (
    <Layout currentPage="employees">
      <div className="w-full h-30 flex justify-center items-center">
        <button onClick={downloadTemplate}>download template</button>
        <label
          className="btn-secondary m-10 cursor-pointer"
          htmlFor="fileUpload"
        >
          Laad csv/xlsx bestand op
        </label>
        <input
          onChange={readFile}
          className="opacity-0 hidden"
          accept=".xlsx, .csv"
          type="file"
          name="fileUpload"
          id="fileUpload"
        />
      </div>

      {!!employees.length && (
        <section>
          <ul className="overflow-scroll h-[250px]">
            <li>
              <pre>{JSON.stringify(Object.keys(employees[0]))}</pre>
            </li>
            <hr />
            {employees.map((emp, index) => {
              return (
                <li key={index}>
                  <pre>{JSON.stringify(Object.values(emp))}</pre>
                </li>
              );
            })}
          </ul>

          <div className="w-full h-30 flex justify-center items-center">
            <button
              className="btn-secondary mr-3"
              onClick={() => setEmployees([])}
            >
              Verwijder
            </button>

            <button className="btn-primary" onClick={saveEmployees}>
              Inschrijven
            </button>
          </div>
        </section>
      )}
      <BulkUploadErrorModal
        errorMessages={bulkUploadErrors}
      ></BulkUploadErrorModal>
    </Layout>
  );
};

export default Bulk;
